import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const adminApi = axios.create({ baseURL: API, withCredentials: true, timeout: 30000 });
export const apiError = (error) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((item) => item.msg).join(" ");
  return "Something went wrong. Please try again.";
};
let refreshing;
adminApi.interceptors.response.use((response) => response, async (error) => {
  const config = error.config;
  if (error.response?.status !== 401 || config?._retried || /auth\/(login|refresh)/.test(config?.url || "")) throw error;
  config._retried = true;
  try {
    if (!refreshing) refreshing = adminApi.post("/auth/refresh").finally(() => { refreshing = null; });
    await refreshing;
    return adminApi(config);
  } catch (refreshError) {
    window.dispatchEvent(new Event("owner-session-expired"));
    throw refreshError;
  }
});

export const coverUrl = (id) => id ? `${API}/covers/${encodeURIComponent(id)}` : null;
export const formatDate = (value) => value ? new Date(value).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "Not published";